// extracted by mini-css-extract-plugin
module.exports = {"container":"_f6a761bc","searchTerm":"_85bcd25b"};